import {
  Avatar,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  Stack,
} from "@mui/material";
import React from "react";

//  five colours for the five days of the week
import { deepPurple, deepOrange, green, blue, red } from "@mui/material/colors";

const colours = [deepPurple, deepOrange, green, blue, red];
const daysOfWeek = ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday"];

function DayOfWeekButton({ day, onClick, ...props }) {
  // get day of week
  const dayName = daysOfWeek[day];
  // get first letter of day
  const firstLetter = dayName[0];

  // get colour
  const colour = colours[day % colours.length];
  return (
    <Avatar
      {...props}
      onClick={() => {
        onClick(dayName);
      }}
      sx={{ bgcolor: colour["500"] }}
    >
      {firstLetter}
    </Avatar>
  );
}

function ClearButton({ onClick, ...props }) {
  return (
    <Button
      {...props}
      onClick={() => {
        onClick("");
      }}
      variant="outlined"
    >
      Clear
    </Button>
    // <Avatar
    //   {...props}
    //   onClick={() => {
    //     onClick("");
    //   }}
    //   sx={{ bgcolor: "#000" }}
    // >
    //   C
    // </Avatar>
  );
}

export default function TaskListScheduleDialog({ open, onClose, onClick }) {
  return (
    <Dialog open={open} onClose={onClose}>
      <DialogContent>
        <Stack direction="row" spacing={2}>
          <DayOfWeekButton day={0} onClick={onClick} />
          <DayOfWeekButton day={1} onClick={onClick} />
          <DayOfWeekButton day={2} onClick={onClick} />
          <DayOfWeekButton day={3} onClick={onClick} />
          <DayOfWeekButton day={4} onClick={onClick} />
        </Stack>
      </DialogContent>
      <DialogActions>
        <ClearButton onClick={onClick} />
      </DialogActions>
    </Dialog>
  );
}
